import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { MovimientoTramite } from './movimiento-tramite.models';

// ADD
export const movimientoTramiteAddRequest = createAction(
  '[MOVIMIENTOTRAMITE] Add Request',
  props<{ item: MovimientoTramite }>()
);

export const movimientoTramiteLoadRequest = createAction(
  '[MOVIMIENTOTRAMITE] Load Request',
)

export const movimientoTramiteLoadSuccess = createAction(
  '[MOVIMIENTOTRAMITE] Load Success',
  props<{ items: MovimientoTramite[] }>()
);

export const movimientoTramiteAddFailure = createAction(
  '[MOVIMIENTOTRAMITE] Add Failure',
  props<{ error: Error }>()
);

export const movimientoTramiteAddSuccess = createAction(
  '[MOVIMIENTOTRAMITE] Add Success',
  props<{ item: MovimientoTramite }>()
);
